import { useUnit } from 'effector-react';
import { $filesState } from '@nx-frontend/shared/store/feature-files';

/**
 * Hook to get file from filesState
 * @param globalId
 * @returns
 */
export function useGetWebnotesFile() {
  const [filesState] = useUnit([$filesState]);

  return (globalId: string) => filesState.entities[globalId];
}
